import styled from 'styled-components';
import { Button, Col } from 'antd';

export const VersionTitle = styled(Col)`
	margin-bottom: 0.5rem;
	font-size: 1.125rem;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.title};
`;

export const ClipRow = styled(Col)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 0.5rem 0;
`;

export const ClipName = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: ${({ theme }) => theme.colors.text};
`;

export const DownloadButton = styled(Button)`
	color: ${({ theme }) => theme.palette.primary[600]};
`;

export const DangerButton = styled(Button)`
	color: ${({ theme }) => theme.colors.danger};

	&:hover,
	&:focus {
		color: ${({ theme }) => theme.colors.danger};
		opacity: 0.7;
	}
`;

export const ClipListArea = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
`;
